<template>
    <div style="margin-top: 10px">
        <div v-if="state.registrantData.total > 0">

            <h4 style="text-align: left">Payment</h4>
            <hr>
            <div class="credit-card-wrapper"></div>
            <form id="payment-form">
                <div class="row">
                    <div class="col-sm-12">
                        <input placeholder="Card number" type="text" name="number" id="number"
                               v-model="state.registrantData.ccInfo.number" style="border-radius: 5px">
                    </div>
                </div>
                <div class="row">
                    <div class="col">

                        <input placeholder="First Name" type="text" name="first-name" id="first-name"
                               v-model="state.registrantData.ccInfo.firstName" style="border-radius: 5px 0 0 5px">
                    </div>
                    <div class="col">
                        <input placeholder="Last Name" type="text" name="last-name" id="last-name"
                               v-model="state.registrantData.ccInfo.lastName">
                    </div>
                    <div class="col">
                        <input placeholder="Billing Zip" type="text" name="zip" id="zip"
                               v-model="state.registrantData.ccInfo.zip" style="border-radius: 0 5px 5px 0">
                    </div>
                </div>
                <div class="row">
                    <div class="col col-sm-3">
                        <input placeholder="MM/YY" type="text" name="expiry" id="expiry"
                               v-model="state.registrantData.ccInfo.expiry" style="border-radius: 5px 0 0 5px">
                    </div>

                    <div class="col col-sm-3">
                        <input placeholder="CVV" type="text" name="cvv" id="cvv"
                               v-model="state.registrantData.ccInfo.cvv">
                    </div>

                    <div v-if="formReady.cc && formReady.form && formReady.terms && state.formstate.signature && formReady.promoEmailReady && formReady.freeRegReady"
                         class="col col-sm-6">
                        <input type="button" :value="payButtonTotal" @click="submitPayment"
                               class="button postfix btn-success" style="border-radius: 0 5px 5px 0">
                    </div>
                    <div v-else class="col col-sm-6">
                        <input type="button" :value="payButtonTotal" @click="formNotComplete"
                               class="button postfix btn-danger" style="border-radius: 0 5px 5px 0">
                    </div>
                </div>
            </form>
        </div>
        <div v-else>
            <div v-if="formReady.form && formReady.terms && state.formstate.signature && formReady.freeRegReady">
                <button v-if="!state.loading" class="btn" @click="submitPayment">Place Order</button>
                <button v-else class="btn" disabled>Place Order</button>
            </div>
            <div v-else>
                <button class="btn btn-danger" @click="formNotComplete">Place Order</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    var card = require('card');

    export default {
        name: 'Payment',
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
            formReady: function () {


                if(this.state.registrantData.regType.price){
                    let regGroups = this.state.registrantData.regType.extraFieldGroupsRequired;
                    let formValid = true;
                    let checkAry = [];

                    regGroups.filter((group) => {
                        if(group === 'trainee' && !this.state.registrantData.proof.name){
                            formValid = false
                        }
                        let item = {
                            group: group,
                            valid: this.state.formstate[group].$valid
                        };
                        checkAry.push(item);
                        if (!this.state.formstate[group].$valid) {
                            formValid = false
                        }
                    });


                    let ccValid = true;
                    if (!this.state.registrantData.ccInfo.number || !this.state.registrantData.ccInfo.expiry || !this.state.registrantData.ccInfo.firstName
                        || !this.state.registrantData.ccInfo.expiry || !this.state.registrantData.ccInfo.lastName || !this.state.registrantData.ccInfo.cvv
                        || !this.state.registrantData.ccInfo.zip) {
                        ccValid = false
                    }

                    let promoEmailReady = true;

                    if(this.state.registrantData.promoReferEmailRequired){
                        if(!this.state.registrantData.promoReferEmail){
                            promoEmailReady = false;
                        }
                    } else{
                        promoEmailReady = true;
                    }

                  let freeRegReady = true;

/*                  if(this.state.registrantData.freeRegEligibiltyRequired){
                    if(!this.state.formstate.reg_eligibilty){
                      freeRegReady = false;
                    }
                  } else{
                    freeRegReady = true;
                  }*/


                    return {
                        form: formValid,
                        cc: ccValid,
                        terms: this.state.formstate.terms,
                        promoEmailReady: promoEmailReady,
                        freeRegReady: freeRegReady
                    };


                }
                else{
                    return {
                        form: false,
                        cc: false,
                        terms: false,
                    };
                }


            },
            payButtonTotal() {
                let output = this.state.registrantData.total;
                output = 'Pay $' + output;
                return output
            }
        },
        methods: {
            submitPayment() {
                console.log('here');
                this.$store.dispatch('sendRequest');
            },
            formNotComplete() {
                alert('Either some form information is incomplete, the terms and conditions have not yet been agreed to or you have not signed the signature box. Please double check for any errors or missing information.')
            }
        },
        mounted: function () {
            var $ = require('jquery');
            window.jQuery = $;

            var card = new Card({
                // a selector or DOM element for the form where users will
                // be entering their information
                form: '#payment-form', // *required*
                // a selector or DOM element for the container
                // where you want the card to appear
                container: '.credit-card-wrapper', // *required*
                formSelectors: {
                    numberInput: 'input#number', // optional — default input[name="number"]
                    expiryInput: 'input#expiry', // optional — default input[name="expiry"]
                    cvcInput: 'input#cvv', // optional — default input[name="cvc"]
                    nameInput: 'input[name="first-name"], input[name="last-name"]' // optional - defaults input[name="name"]
                },
                width: 300, // optional — default 350px
                formatting: true, // optional - default true
                // Strings for translation - optional
                messages: {
                    validDate: 'valid\ndate', // optional - default 'valid\nthru'
                    monthYear: 'mm/yyyy', // optional - default 'month/year'
                },
                // Default placeholders for rendered fields - optional
                placeholders: {
                    number: '•••• •••• •••• ••••',
                    name: 'Full Name',
                    expiry: '••/••',
                    cvc: '•••'
                },
                masks: {
                    cardNumber: '' // optional - mask card number
                },
                // if true, will log helpful messages for setting up Card
                debug: false // optional - default false
            })
        },
    }
</script>

<style scoped>
    .smaller-cont {
        width: 80%;
        margin: 0 auto;
    }

    .sm-nav {
        display: flex;
        border-bottom: 1px solid #b4b4b4;
    }

    .sm-nav .btn {
        border-radius: 5px 5px 0 0;
    }

    .active {
        background-color: #a7a7a7;
        color: white;
    }

    #payment-form input[type="text"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        border-radius: 0;
        background-color: #FFFFFF;
        border-style: solid;
        border-width: 1px;
        border-color: #cccccc;
        -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
        color: rgba(0, 0, 0, 0.75);
        display: block;
        font-family: inherit;
        font-size: 0.875rem;
        height: 2.3125rem;
        margin: 0 0 1rem 0;
        padding: 0.5rem;
        width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-transition: border-color 0.15s linear, background 0.15s linear;
        transition: border-color 0.15s linear, background 0.15s linear;
    }

    #payment-form div[class*=col] {
        padding-left: 0;
        padding-right: 0;
    }

    .postfix.button {
        border: none;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
        padding-top: 0;
        text-align: center;
        font-size: 0.875rem;
        height: 2.3125rem;
        line-height: 2.3125rem;
        overflow: visible;
        width: 100%;
        z-index: 2;
    }
</style>
